/* eslint-disable @typescript-eslint/no-unused-vars */
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import MainLayout from 'views/layouts/Main'
import ModalQuestions from './modal-questions'
import {
  Container,
  StepsContainer,
  NextButtonContainer,
  Row,
  TitleContainer,
  TitleIcon,
  DescriptionContainer,
  SkillsContainer,
  TextArea,
  TextAreaContainer,
  SkillsTitleContainer,
  EachSkillContainer,
  DeleteContainer,
  QuestionIndicator,
  QuestionCircleIcon,
  EditButtonContainer,
  TextCardContainer,
  CharCounter,
} from './styled'
import { H2, H4, H5, P } from 'views/components/UI/Text'
import Steps from 'views/components/Stepper'
import ModalLoader from 'views/components/UI/ModalLoader/modal-loader'
import { Button, BackButton, StrokedButton } from 'views/components/UI/Buttons'
import { useNotification } from 'lib/context/notification.context'
import { STEPS_NEW_PROCESS_360 } from '../constants'
import { rootProcessSelector, stepThreeSelector, stepFourSelector } from 'ducks/createProcess'
import { generalDataSelector } from 'ducks/auth'
import _ from 'lodash'
import { useTranslation } from 'react-i18next'
import { companyIdSelector } from 'ducks/user'
import { selectCompanyData } from 'ducks/company'
import threeSixtyIcon from 'assets/images/360-clean-icon.png'
import Input from 'views/components/UI/TextInput'
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline'
import DeleteIcon from 'assets/icons/DeleteIcon'
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted'
import EditIcon from 'assets/icons/EditCoin'
import ModalDelete from './modal-delete'
import SkillsSummary from './skillsSummary'
import {
  selectTest360Data,
  selectShowSummary,
  selectShowIntro,
  set360Data,
  setShowSummary as setReduxShowSummary,
  setShowIntro as setReduxShowIntro,
  setHas360Test,
} from 'ducks/test360'
import ModalCleanup from './modal-cleanup'
import { usePreventNavigation } from 'views/screens/super-admin/homologation-skills/hooks/usePreventNavigation'
import { platformAdminRoutes } from 'router/routes'
import test360CreateDraft from 'services/process/test360/test360CreateDraft'
import test360UpdateDraft from 'services/process/test360/test360UpdateDraft'

export interface Filters {
  levelId: number
  groupId?: number
  name?: string
  page: number
}

interface ThreeDSkillsProps {
  id: number
  name: string
}

export interface ModelSkillsProps {
  id: number
  name: string
  skills3d: ThreeDSkillsProps[]
}

export interface SkillProps360 {
  name: string
  description: string
  questions: string[]
}

const Test360 = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const dispatch = useDispatch()
  const { getWarning, getError, getSuccess } = useNotification()
  const dataStepFour = useSelector(stepFourSelector)
  const companyId = useSelector(companyIdSelector)
  const companyInfo = useSelector(selectCompanyData)
  const test360Data = useSelector(selectTest360Data)
  const summaryVisible = useSelector(selectShowSummary)
  const introVisible = useSelector(selectShowIntro)
  const { process } = useSelector(rootProcessSelector)
  const stepTwoData = useSelector(rootProcessSelector).process.stepTwo
  const stepThreeData = useSelector(stepThreeSelector)
  const { data: generalData } = useSelector(generalDataSelector)

  const level: number = process.stepOne.level

  const [loading, setLoading] = useState<boolean>(false)
  const [showIntro, setShowIntro] = useState<boolean>(true)
  const [skills360, setSkills360] = useState<SkillProps360[]>([{ name: '', description: '', questions: [] }])
  const [showQuestionsModal, setShowQuestionsModal] = useState<boolean>(false)
  const [currentSkillIndex, setCurrentSkillIndex] = useState<number>(0)
  const [originalSkillQuestions, setOriginalSkillQuestions] = useState<string[]>([])
  const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false)
  const [skillIndexToDelete, setSkillIndexToDelete] = useState<number | null>(null)
  const [showSummary, setShowSummary] = useState<boolean>(false)
  const [showCleanupModal, setShowCleanupModal] = useState<boolean>(false)

  useEffect(() => {
    if (test360Data.length) {
      setSkills360(test360Data)
    }
  }, [test360Data])

  useEffect(() => {
    setShowSummary(summaryVisible)
  }, [summaryVisible])

  useEffect(() => {
    setShowIntro(introVisible)
  }, [introVisible])

  const handleBackButton = () => {
    if (stepTwoData.isRoleFamilySelected) {
      navigate(platformAdminRoutes.PreconfigProcess, { state: { goBack: true } })
    } else if (stepTwoData?.configurationMode === 'ai_ideal_profile') {
      navigate(platformAdminRoutes.IdealProfileGeneratorAi)
    } else {
      if (stepThreeData.useSkillsTest) {
        navigate(platformAdminRoutes.ProcessSkills, { state: { back: true } })
      } else if (stepThreeData.useBetesaTest) {
        navigate(platformAdminRoutes.IdealProfileBetesa)
      } else {
        navigate(platformAdminRoutes.SelectTestsType)
      }
    }
  }

  const handleBackAndClean = () => {
    if (stepThreeData.useSkillsTest) {
      navigate(platformAdminRoutes.ProcessSkills)
    } else if (stepThreeData.useBetesaTest) {
      navigate(platformAdminRoutes.HomologationSkills)
    } else {
      setShowCleanupModal(true)
    }
  }

  const handleClickIntro = () => {
    const newIntroState = !showIntro
    setShowIntro(newIntroState)
    dispatch(setReduxShowIntro(newIntroState))
  }

  const handleSkillChange = (index: number, field: string, value: string) => {
    const updatedSkills = [...skills360]
    updatedSkills[index] = { ...updatedSkills[index], [field]: value }
    setSkills360(updatedSkills)
  }

  const handleAddSkill = () => {
    if (skills360.length < 10) {
      setSkills360([...skills360, { name: '', description: '', questions: [] }])
    } else {
      getWarning('No puedes agregar más de 10 competencias')
    }
  }

  const handleRemoveSkill = (index: number) => {
    setSkillIndexToDelete(index)
    setShowDeleteModal(true)
  }

  const handleConfirmDeleteSkill = async () => {
    setLoading(true)
    try {
      if (skillIndexToDelete !== null) {
        const updatedSkills = [...skills360]
        updatedSkills.splice(skillIndexToDelete, 1)
        const body = {
          test360: {
            skills360: updatedSkills,
            step: 1,
          },
        }
        const updateResponse = await test360UpdateDraft(stepThreeData.processId, body)

        // Manejar error 402 de créditos insuficientes
        if (updateResponse && updateResponse.success === false && updateResponse.message) {
          getError(updateResponse.message)
          setLoading(false)
          return
        }

        setSkills360(updatedSkills)
        setSkillIndexToDelete(null)
        setShowDeleteModal(false)
        getSuccess('Competencia eliminada correctamente')
        setLoading(false)
      } else {
        getError('No se pudo eliminar la competencia. Por favor, inténtalo de nuevo.')
        setLoading(false)
      }
    } catch (error) {
      setLoading(false)
      console.error('Error al eliminar la competencia:', error)
      getError('Ocurrió un error al eliminar la competencia. Por favor, inténtalo de nuevo.')
    }
  }

  const handleCancelDeleteSkill = () => {
    setSkillIndexToDelete(null)
    setShowDeleteModal(false)
  }

  const handleAddQuestion = (skillIndex: number) => {
    // Guardar una copia del estado original de las preguntas antes de abrir el modal
    const originalQuestions = [...skills360[skillIndex].questions]
    console.log('Guardando estado original de preguntas:', originalQuestions)
    setOriginalSkillQuestions(originalQuestions)
    setCurrentSkillIndex(skillIndex)
    setShowQuestionsModal(true)
  }

  const handleCloseQuestionsModal = () => {
    // Solo cerramos el modal pero mantenemos el estado original
    setShowQuestionsModal(false)
  }

  // Función para restaurar el estado anterior cuando se cancela el modal
  const handleCancelQuestionsModal = () => {
    try {
      // Verificar que tengamos datos válidos
      if (currentSkillIndex !== undefined && originalSkillQuestions) {
        console.log('Intentando restaurar preguntas al estado original:', {
          skillIndex: currentSkillIndex,
          originalPreguntas: originalSkillQuestions,
        })

        // Crear una copia profunda del estado actual
        const updatedSkills = JSON.parse(JSON.stringify(skills360))

        // Restaurar las preguntas al estado original
        updatedSkills[currentSkillIndex].questions = [...originalSkillQuestions]

        // Actualizar el estado
        setSkills360(updatedSkills)

        console.log('Estado restaurado correctamente:', updatedSkills[currentSkillIndex].questions)
      } else {
        console.error('Error al restaurar: índice o preguntas originales no válidos')
      }
    } catch (error) {
      console.error('Error al restaurar el estado original:', error)
    }
  }

  const handleAddQuestionFromModal = (question: string) => {
    // Crear una copia profunda para evitar problemas de referencia
    const updatedSkills = JSON.parse(JSON.stringify(skills360))
    const currentQuestions = updatedSkills[currentSkillIndex].questions

    if (currentQuestions.length < 6) {
      // Añadir la nueva pregunta
      updatedSkills[currentSkillIndex].questions = [...currentQuestions, question]
      setSkills360(updatedSkills)
      console.log('Pregunta añadida. Preguntas actuales:', updatedSkills[currentSkillIndex].questions)
    } else {
      getWarning('No puedes agregar más de 6 preguntas por competencia')
    }
  }

  const handleRemoveQuestion = (questionIndex: number) => {
    // Validar que el índice existe
    if (questionIndex < 0 || questionIndex >= skills360[currentSkillIndex]?.questions?.length) {
      console.error('Índice de pregunta inválido:', questionIndex)
      return
    }

    // Crear una copia profunda para evitar problemas de referencia
    const updatedSkills = JSON.parse(JSON.stringify(skills360))

    // Eliminar la pregunta
    updatedSkills[currentSkillIndex].questions.splice(questionIndex, 1)
    setSkills360(updatedSkills)

    // Log para fines de depuración
    console.log('Pregunta eliminada. Preguntas actuales:', updatedSkills[currentSkillIndex].questions)
  }

  const handleUpdateQuestion = (questionIndex: number, value: string) => {
    // Crear una copia profunda para evitar problemas de referencia
    const updatedSkills = JSON.parse(JSON.stringify(skills360))

    // Actualizar el valor de la pregunta
    updatedSkills[currentSkillIndex].questions[questionIndex] = value
    setSkills360(updatedSkills)
  }

  const isLastSkillComplete = () => {
    if (skills360.length >= 10) return false

    if (skills360.length === 0) return true

    const lastSkill = skills360[skills360.length - 1]
    return lastSkill.name.trim() !== '' && lastSkill.description.trim() !== '' && lastSkill.questions.length > 0
  }

  const validateSkills = () => {
    // Verificar si hay competencias completamente vacías
    const emptySkills = skills360.filter(
      (skill) => skill.name.trim() === '' && skill.description.trim() === '' && skill.questions.length === 0
    )

    // Verificar si hay competencias con datos parciales (al menos uno de los campos tiene contenido)
    const skillsWithSomeData = skills360.filter(
      (skill) => skill.name.trim() !== '' || skill.description.trim() !== '' || skill.questions.length > 0
    )

    // Verificar si hay competencias completamente válidas
    const completeSkills = skills360.filter(
      (skill) => skill.name.trim() !== '' && skill.description.trim() !== '' && skill.questions.length > 0
    )

    // Si hay competencias completamente vacías (excepto si es la primera y única competencia inicial)
    if (emptySkills.length > 0 && !(skills360.length === 1 && emptySkills.length === 1)) {
      return {
        isValid: false,
        message: 'Debes completar todos los campos de las competencias o eliminar las competencias vacías.',
      }
    }

    // Si no hay ninguna competencia completa
    if (completeSkills.length === 0) {
      return {
        isValid: false,
        message: 'Debes completar al menos una competencia con nombre, descripción y preguntas.',
      }
    }

    // Verificar que todas las competencias con datos parciales estén completas
    for (const skill of skillsWithSomeData) {
      if (skill.name.trim() === '') {
        return {
          isValid: false,
          message: 'Todas las competencias deben tener un nombre.',
        }
      }
      if (skill.description.trim() === '') {
        return {
          isValid: false,
          message: 'Todas las competencias deben tener una descripción.',
        }
      }
      if (skill.questions.length === 0) {
        return {
          isValid: false,
          message: 'Todas las competencias deben tener al menos una pregunta.',
        }
      }
    }

    return { isValid: true, message: '' }
  }

  const handleNextButton = async () => {
    // Validar antes de proceder
    const validation = validateSkills()
    if (!validation.isValid) {
      getWarning(validation.message)
      return
    }

    setLoading(true)
    try {
      const body = {
        test360: {
          skills360,
          process_id: stepThreeData.processId,
          step: 1,
        },
      }
      const createDraft = await test360CreateDraft(body)
      if (!createDraft.success) {
        getError(createDraft.message)
        setLoading(false)
        return
      }
      dispatch(set360Data(skills360))
      setShowSummary(true)
      dispatch(setReduxShowSummary(true))
      setLoading(false)
    } catch (error) {
      console.error('Error al manejar el botón Siguiente:', error)
      getError('Ocurrió un error al procesar los datos. Por favor, inténtalo de nuevo.')
      setLoading(false)
    }
  }

  const disableNextButton = () => {
    const validation = validateSkills()
    return !validation.isValid
  }

  const handleDisabledNextButtonClick = () => {
    const validation = validateSkills()
    if (!validation.isValid) {
      getWarning(validation.message)
    }
  }

  // MARK: CLEANUP

  const handleCleanup = () => {
    // Reset local state
    setSkills360([{ name: '', description: '', questions: [] }])
    setShowIntro(true)
    setShowSummary(false)
    setShowQuestionsModal(false)
    setCurrentSkillIndex(0)
    setOriginalSkillQuestions([])
    setShowDeleteModal(false)
    setSkillIndexToDelete(null)
    setShowCleanupModal(false)
    // Reset Redux state
    dispatch(set360Data([]))
    dispatch(setReduxShowSummary(false))
    dispatch(setReduxShowIntro(true))
    dispatch(setHas360Test(false))
  }

  const { isModalOpen, handleClose, handleConfirm } = usePreventNavigation({
    shouldPrevent: true,
    onNavigationAttempt: handleCleanup,
  })

  const handleCloseConfirmModal = () => {
    setShowCleanupModal(false)
    handleClose()
  }

  // MARK: RENDER

  return (
    <MainLayout>
      <Container>
        <TitleContainer>
          <TitleIcon src={threeSixtyIcon} alt="threeSixtyIcon" />
          <H2 margin="30px 0px 24px 0px">{t('global.common.threeSixtyText')}</H2>
        </TitleContainer>
        <StepsContainer>
          <Steps steps={STEPS_NEW_PROCESS_360} activeStep={3} />
        </StepsContainer>
        {showIntro ? (
          <>
            <DescriptionContainer>
              <H4
                style={{
                  width: '100%',
                }}
                margin="30px 0px 24px 0px"
              >
                Configuración de la evaluación 360°
              </H4>
              <P>
                La evaluación 360° es personalizable, podrás ingresar hasta 10 competencias y a cada competencia podrás
                asignarles hasta 6 preguntas o comportamientos a evaluar.
              </P>

              <P>
                Cada persona evaluada podrá recibir retroalimentación de hasta 12 evaluadores diferentes. Además, la
                prueba incluye una autoevaluación obligatoria, por lo que cada colaborador tendrá entre 2 y 13
                evaluaciones en total.
              </P>
            </DescriptionContainer>
            <NextButtonContainer>
              <BackButton onClick={handleBackButton} />
              <Button onClick={handleClickIntro} type="button">
                Agregar competencias
              </Button>
            </NextButtonContainer>
          </>
        ) : !showSummary ? (
          <>
            <DescriptionContainer style={{ margin: '0px 0px 0px 10px' }}>
              <H4
                style={{
                  width: '100%',
                }}
                margin="30px 0px 24px 0px"
              >
                Competencias a evaluar
              </H4>
              <P>
                Ingresa la información de las competencias que deseas evaluar y asigna a cada una hasta 6 ítems. Puedes
                evaluar hasta 10 competencias.
              </P>
            </DescriptionContainer>
            <SkillsContainer>
              {skills360.map((skill, index) => (
                <EachSkillContainer key={`360-skills-${index}`}>
                  {skills360.length > 1 ||
                  (skills360[0].name && skills360[0].description && skills360[0].questions.length) ? (
                    <DeleteContainer onClick={() => handleRemoveSkill(index)}>
                      <DeleteIcon />
                      Eliminar competencia
                    </DeleteContainer>
                  ) : null}
                  <SkillsTitleContainer>
                    <H5 style={{ fontWeight: 'normal' }} margin="0">
                      0{index + 1}.
                    </H5>
                    <Input
                      value={skill.name}
                      onChange={(e) => handleSkillChange(index, 'name', e.target.value)}
                      type="text"
                      name="skillName"
                      label="Nombre de la competencia"
                    />
                  </SkillsTitleContainer>
                  <TextAreaContainer>
                    <TextArea
                      value={skill.description}
                      onChange={(e) => handleSkillChange(index, 'description', e.target.value)}
                      name="skillDescription"
                      placeholder="Descripción de la competencia"
                      maxLength={250}
                    />
                    <CharCounter isExceeded={skill.description.length > 250}>
                      {skill.description.length}/250
                    </CharCounter>
                  </TextAreaContainer>
                  {skill.questions.length > 0 ? (
                    <QuestionIndicator>
                      <QuestionCircleIcon>
                        <FormatListBulletedIcon fontSize="small" />
                      </QuestionCircleIcon>
                      <TextCardContainer>
                        <P margin="0">Preguntas asociadas {skill.questions.length}</P>
                        <EditButtonContainer onClick={() => handleAddQuestion(index)}>
                          <EditIcon />
                          Editar
                        </EditButtonContainer>
                      </TextCardContainer>
                    </QuestionIndicator>
                  ) : (
                    <StrokedButton
                      onClick={() => handleAddQuestion(index)}
                      style={{ marginTop: '20px', display: 'flex', alignItems: 'center', width: 'fit-content' }}
                      type="button"
                      disabled={skill.questions.length >= 6}
                    >
                      <AddCircleOutlineIcon style={{ marginRight: '5px', color: '#2D749C' }} />
                      Añadir preguntas
                    </StrokedButton>
                  )}
                </EachSkillContainer>
              ))}
              <StrokedButton
                onClick={handleAddSkill}
                type="button"
                style={{ marginTop: '20px', width: 'fit-content' }}
                disabled={!isLastSkillComplete()}
              >
                Nueva competencia
              </StrokedButton>
            </SkillsContainer>
            <NextButtonContainer>
              <BackButton onClick={handleBackAndClean} />
              <Button
                onClick={handleNextButton}
                onDisabledClick={handleDisabledNextButtonClick}
                disabled={disableNextButton()}
                type="button"
              >
                Siguiente
              </Button>
            </NextButtonContainer>
          </>
        ) : (
          <SkillsSummary skills360={skills360} setSkills360={setSkills360} setShowSummary={setShowSummary} />
        )}
        <ModalLoader isLoading={loading} />
        <ModalQuestions
          showModal={showQuestionsModal}
          handleClose={handleCloseQuestionsModal}
          skillIndex={currentSkillIndex}
          skillName={currentSkillIndex !== undefined ? skills360[currentSkillIndex]?.name : ''}
          questions={currentSkillIndex !== undefined ? skills360[currentSkillIndex]?.questions : []}
          onAddQuestion={handleAddQuestionFromModal}
          onRemoveQuestion={handleRemoveQuestion}
          onUpdateQuestion={handleUpdateQuestion}
          onCancel={handleCancelQuestionsModal}
        />
        <ModalDelete
          showModal={showDeleteModal}
          handleClose={handleCancelDeleteSkill}
          handleRemoveSkill={handleConfirmDeleteSkill}
        />
        <ModalCleanup
          showModal={showCleanupModal || isModalOpen}
          handleClose={handleCloseConfirmModal}
          handleCleanup={handleConfirm}
        />
      </Container>
    </MainLayout>
  )
}

export default Test360
